import React from 'react';
import styled from 'styled-components';
import { Emoji } from 'emoji-mart'

import { GoogleButton } from 'features';
import GoogleLoginButton from 'resources/google_signin_dark.png'

const Container = styled.div`
    width: 100%;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: var(--primary-color);
    border: 2px solid transparent;
    cursor: pointer;
    :hover{
        border: 2px solid var(--focus-color);
    }
`

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${props => props.justify};
    width: 100%;
`

const Column = styled.div`
    display: flex;
    flex-direction: column;
`

const Icon = styled.img`
    height: 1rem;
    width: 1rem;
    object-fit: contain;
    src: ${props => props.icon};
    margin: 0 0.5rem 0 0;
    padding: 0.2rem;
    border-radius: 5px;
    /* border: 1px solid var(--primary-accent-color); */
    /* background: var(--secondary-color); */
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    color: var(--secondary-accent-color);
`

const OptionBlock = props => {
    const {
        title,
        icon,
        onSelect,
        google
    } = props;
    
    return (
        <Container onClick={onSelect}>
            <Row justify='space-between'>
                <Row>
                    {!icon ? null
                    : icon['type'] === 'link' ? <Icon src={icon['value']}/>
                    : icon['type'] === 'emoji' ? <div style={{margin: '0 0.5rem 0 0'}}><Emoji emoji={icon['value']} size={'1rem'}/></div>
                    : icon['type'] === 'element' ? <div style={{margin: '0 0.5rem 0 0', height: '1rem', width: '1rem'}}>{icon['value']}</div>
                    : null}
                    <Column>
                        <Title>{title}</Title>
                    </Column>
                </Row>
                {google && <GoogleButton text='Sign in with Google'/>}
                {/* <img src={GoogleLoginButton} style={{height: '2rem', objectFit:'contain'}}/> */}
            </Row>
        </Container>
    )
}

export default OptionBlock;